<h2 mat-dialog-title>
  {{ 'SHARE.SHARE_FORM' | translate }}
</h2>
<mat-dialog-content>
  <glxy-form-field>
    <glxy-label>{{ 'SHARE.ADD_OR_SELECT_USERS' | translate }}</glxy-label>
    <mat-chip-grid #emailList [attr.aria-label]="'SHARE.EMAIL_ADDRESSES' | translate" required>
      <mat-chip-row *ngFor="let e of selectedUsers" (removed)="remove(e.userId)">
        {{ e.email }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
      <input
        [placeholder]="'SHARE.ADD_OR_SELECT_USERS' | translate"
        #emailInput
        [formControl]="emailControl"
        [matAutocomplete]="autoEmail"
        [matChipInputFor]="emailList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      />
    </mat-chip-grid>
    <mat-error>{{ errorMessage$$ | async }}</mat-error>
    <mat-autocomplete #autoEmail="matAutocomplete" (optionSelected)="selected($event)">
      <ng-container *ngIf="filteredUsers$ | async as users">
        <mat-option *ngFor="let u of users" [value]="u.userId" (mousedown)="preventBlur($event)">
          {{ u | formatUser }}
        </mat-option>
        <mat-option *ngIf="users && allowUserManagement" (click)="presentAddUserDialog()" class="add-user">
          <mat-icon>add</mat-icon>
          {{ 'SHARE.ADD_USER' | translate }}
        </mat-option>
      </ng-container>
    </mat-autocomplete>
  </glxy-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close(false)" data-action="share-work-order-form-cancel-button">
    {{ 'SHARE.CANCEL' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    data-action="share-work-order-form-submit-button"
    (click)="close(true)"
    [disabled]="(errorMessage$$ | async) !== '' && (errorMessage$$ | async) !== null"
  >
    {{ 'SHARE.SHARE' | translate }}
  </button>
</mat-dialog-actions>
